import React, { useEffect, useRef, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { barcodeScan, bm_date, drawPrice, istl, showConfirm } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Cell from "../ui/Cell";
import Input from "../ui/Input";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { playSounds, monthsOld } from "../utils/Utils";
import Cookies from 'js-cookie';

export default function ReconciliationList(props) {

    const {
        controller = "",
        signal = {},
        view = "",
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        filters = { sort: "id", localSort: "id" },
        setFilters = () => { },
        route = "",
        align = "auto",
        setAlign = () => { },
        seachResults = {},
        isTitleLink = false,
        edit = false,
        isNew = false,
        setIsNew = () => { },
        updateRow = () => { },
    } = props;

    const deletePreviousRow = () => {
        if (data.length < 2) {
            return;
        }

        // assume the last row is the fake 'new' row
        const lastIndex = data.length - 2;
        let _id = data[lastIndex]?.reconciliation_id;
        if (!_id) {
            showError({ error: "No previous record." });
            return;
        }

        pubCall("reconciliation.delete", { reconciliation_id: _id }, (_s, _r) => {
            if (_s) {
                let _data = [...data].filter(item => item.reconciliation_id !== _id);
                setData(_data);
                setSelected((_data.length > 0) ? _data[_data.length - 1] : {});
            } else {
                showError(_r);
            }
        });
    }

    const submitCount = (_force = false, _string = getVal("new_code"), _count = getVal("new_count")) => {

        _string = _string.replace("~", "");
        _string = _string.toUpperCase();
        _string = _string.trim();

        if (!_string) {
            showError({ error: "ISBN Required" });
            return;
        }

        _count = getVal("new_count").toString();
     
        if (_count.startsWith("-")) {
            _count = parseInt(_count.substring(1, _count.length));
            _count = _count * -1;
        } else {
            _count = parseInt(_count);
        }

        let _char = _string.substring(0, 1);

        // Delete Previous
        if (_string === "D") {
            deletePreviousRow();
            setTabs([
                { key: "new_code", value: "" },
                { key: "new_count", value: 1 },
            ])
            return;
        }

        // Increment 1 or 2 digit number
        if (_string.length === 1 || _string.length === 2) {
            if (!isNaN(parseInt(_string))) {
                setTabs([
                    { key: "new_code", value: "" },
                    { key: "new_count", value: parseInt(_string) },
                ])


                return;
            }

        }

        // Update count
        if (_char === "-" || _char === "+") {
            let _amount = parseInt(_string.substring(1, _string.length));
            _amount = (_char === "-") ? _amount * -1 : _amount;

            if(!_amount){
                _amount = -1; 
            }
            if (_amount) {
                update("new_code", "");
                update("new_count", _amount);

                return;
            }

        }


        let _filters = { ...filters };
        _filters.primary_code = _string;
        _filters.condition_code = " ";
        _filters.count = (_count) ? _count : 1;

        if (_force) {
            _filters.ignore_new_warning = true
        }


        pubCall("reconciliation.submitAdditive", { ..._filters, "limit": 20 }, (_status, _result) => {
            if (_status) {
                // play audio
                const lastItem = _result[_result.length - 1];
                playRecSound(lastItem.counted, lastItem.onhand, lastItem?.stock_data?.receive_date, true, !_force);

                // load last
                const _new = { reconciliation_id: "new", primary_code: "", is_new: true, counted: 1 };
                console.log(data);
                console.log(_result.concat([_new]))
                setData(_result.concat([_new]));
                setTabs([
                    { key: "new_code", value: "" },
                    { key: "new_count", value: 1 },
                ])

            } else {
                // play error sounds
                playRecSound(0, 0, false, false, true);
                if (_result.error === "com.bmo.does_not_exist") {
                    refs.current[index].blur();
                    showConfirm({
                        controller: controller,
                        route: ROUTES.RECONCILIATION.NEW, title: "Warning", description: <div style={{ "textAlign": "center" }}><strong>{_string}</strong><br /> not found. Keep?</div>, callback: (_key) => {
                            if (_key) {
                                submitCount(true, _string, _count);
                            }
                            refs.current[index].focus();
                        }
                    })
                } else {
                    showError(_result)
                }
            }
        })

    }

    const playRecSound = (_count, _onhand, _old = false, _found = true, _play_scanned = true) => {
        // Setup sounds object
        let sounds = {
            "play_sounds": true,
            "play_scanned": true,
            "play_short": true,
            "play_even": true,
            "play_over": true,
            "play_not_found": true,
            "play_months": 0,
        };

        // Overwrite with cookies
        if (Cookies.get("rec_sounds")) {
            sounds = JSON.parse(Cookies.get("rec_sounds"))
        }

        if (!sounds.play_sounds) {
            return;
        }

        // Create sounds array
        let _sounds = [];

        // Scanned
        if (sounds.play_scanned && _play_scanned) {
            _sounds.push("play_scanned")
        }

        // Error
        if (!_found) {
            if (sounds.play_not_found) {
                _sounds.push("play_not_found");
                playSounds(_sounds);
            }
            return;
        }

        // Under
        if ((_count < _onhand) && (sounds.play_short)) {
            _sounds.push("play_short");
        }

        // Even
        if ((_count === _onhand) && (sounds.play_even)) {
            _sounds.push("play_even");
        }

        // Over
        if ((_count > _onhand) && (sounds.play_over)) {
            _sounds.push("play_over");
        }

        // Old
        if (_old && (sounds.play_months)) {
            let _months_old = monthsOld(_old);
            let _oldint = parseInt(sounds.play_months)
            if (_oldint > 0) {
                if (_months_old >= _oldint) {
                    _sounds.push("play_old");
                }
            }
        }

        playSounds(_sounds);
    }

    const [index, setIndex] = useState("new_count");

    const [tabs, setTabs] = useState([
        { key: "new_code", value: "" },
        { key: "new_count", value: 1 },
    ])

    const toggleIndex = (_ind) => {

        if (refs?.current) {
            refs.current[_ind].focus();
        }

    }

    const onBarcode = (_barcode) => {
        alert(_barcode)

    }

    const closeNew = () => {
        window.bm_state.value = ROUTES.RECONCILIATION.RECONCILIATION;
        let _d = [...data].filter(item => item.reconciliation_id !== "new");
        setData(_d);
        setSelected(_d.length > 0 ? _d[_d.length - 1] : {});
        setIsNew(false);
    }

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { closeNew() } },
            // { key: KBD.ENTER, action: (e) => { submitCount() } },
            { key: KBD.ARROW_UP, action: (e) => toggleIndex("new_count") },
            { key: KBD.ARROW_DOWN, action: (e) => { toggleIndex("new_code") } },
        ];
        const cleanup = listen(controller, ROUTES.RECONCILIATION.NEW, actions, false, [KBD.ESCAPE, KBD.ENTER, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TILDE]);
        return cleanup;
    }, [tabs, data]);









    const refs = useRef([]);

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        controlled: true,
        autoselect: true,
        onChange: (e) => update(index, e)
    });

    const countProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        autoselect: true,
        onChange: (e) => update(index, e)
    });


    const buffer = 20;


    const min = (view === "inventory") ? false : true;

    const toggleSort = (_key) => {
        if (filters.sort === _key) {
            setFilters({ ...filters, "sort": "id", "dynamic": true })
        } else {
            setFilters({ ...filters, "sort": _key, "dynamic": true })
        }
    }


    const toggleLocalSort = (_key) => {

        let _f = "reconciliation_id";
        if (data.length > 0 && data[0].hasOwnProperty("init")) {
            _f = "init";
        }

        if (filters.localSort === _key) {
            setFilters({ ...filters, "localSort": [_f], "dynamic": false })
        } else {
            setFilters({ ...filters, "localSort": _key, "dynamic": false })
        }

    }




    const columns = [
        {
            key: "counted", title: <>Count</>, align: "right", width: 45, render: (e, f) => {

                if (isNew && f.reconciliation_id === "new") {
                    return (
                        <div style={{ "position": "relative", "margin": "-5px -5px", "lineHeight": "50px" }}>
                            <Input {...editProps("new_count")} right maxLength={3} style={{ "height": "31px", "paddingRight": "5px" }} value={getVal("new_count")} cell edit />
                        </div>
                    )
                } else
                    if (edit === f.reconciliation_id) {
                        return (
                            <div style={{ "position": "relative", "margin": "-5px -5px", "lineHeight": "50px" }}>
                                <Input onChange={(e) => updateRow({ ...selected, "counted": e })} value={e} autofocus autoselect right maxLength={3} style={{ "height": "31px", "paddingRight": "5px" }} cell edit />
                            </div>
                        )
                    } else {
                        return e;
                    }
            }
        },
        { key: "onhand", title: <>O/H</>, align: "right", width: 35 },
        {
            key: "diff", title: <span style={{ "color": (filters.oh_filter) ? "var(--text-yellow)" : "inherit" }}>Diff</span>, align: "right", width: 35, render: (e, f) => {
                if (f?.primary_code === "new") {
                    return ("")
                }
                if (f?.is_new) {
                    return (<></>)
                }
                let _oh = parseInt(f.onhand) || 0;
                let _ct = parseInt(f.counted) || 0;
                let _ret = _ct - _oh || ""
                return (<strong style={{ "color": "var(--text-red)" }}>{_ret}</strong>);
            }
        },
        {
            key: "primary_code", title: <>ISBN</>, grow: true, width: 162, render: (e, f) => {
                if (isNew && f.reconciliation_id === "new") {
                    return (
                        <div style={{ "position": "relative", "margin": "-5px -5px", "lineHeight": "50px" }}>
                            <Input {...countProps("new_code")} onEnter={(e) => {
                                submitCount(false, e, 1)
                            }} right maxLength={14} style={{ "height": "31px", "paddingRight": "5px" }} autofocus cell edit />
                            {/* <Input notilde {...editProps("new_code")} right maxLength={13} style={{ "height": "31px", "paddingRight": "5px" }} value={getVal("new_code")} autofocus cell edit /> */}
                        </div>
                    )
                } else {
                    return e;
                }
            }
        },
        { key: "condition_code", title: <>Cond</>, width: 40 },
        { key: "title", title: <>Title</>, grow: true, width: 290 },
        { key: "price", title: <>Price</>, align: "right", width: 65, render: (e) => drawPrice(e, true) },
        {
            key: "class", title: <>Class</>, grow: true, render: (e, f) => {
                return (f?.category_1 && f?.category_2) ? f?.category_1 + "-" + f?.category_2 : f?.category_1;
            }, width: 150
        },
        { key: "work_station", title: <span style={{ "color": (filters.work_station_filter) ? "var(--text-yellow)" : "inherit" }}>WS</span>, align: "right", width: 35 }
    ]


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.reconciliation_id === selected?.reconciliation_id) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.reconciliation_id === selected?.reconciliation_id) - _rows;


        if (prevIndex < 1) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {

        if (loading) { return }

        setLoading(true);
        pubCall("reconciliation.getNext", { ...filters, "limit": 20, "reconciliation_id": data[data.length - 1]?.reconciliation_id }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("reconciliation.getPrevious", { ...filters, "limit": 20, "reconciliation_id": data[0]?.reconciliation_id }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const getStart = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("reconciliation.getInitial", { ...filters, "limit": 20 }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.rows_next]);
                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const getEnd = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("reconciliation.getLast", { ...filters, "limit": 20 }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r]);
                setSelected((_r.length > 0) ? _r[_r.length - 1] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }




    return (
        <>

            <VirtualTable
                controller={controller}
                className={(view === "reconciliation") ? "" : "desaturate"}
                onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                onRowClick={(item, event, index) => { if (window.bm_state.value === route) { setAlign("auto"); setSelected(item); } }}
                next={next}
                prev={prev}
                getStart={getStart}
                getEnd={getEnd}
                align={align}
                row_key={"reconciliation_id"}
                current={selected}
                data={data}
                columns={columns}
                width={960}
                loading={loading}
                offset={439}
                height={215}
                route={route}
            />
        </>
    )
}